<template>
    <div>
        <div style="max-height: 200px; overflow: auto;" class="horizontal_scrollbar vertical_scrollbar">
            <div class="flex items-center" v-for="i in 4" :key="i.id">
                <div style="min-width: 200px;" class="p-2">
                    <v-select class="w-full" placeholder="Subject"></v-select>
                </div>
                <div style="min-width: 200px;" class="p-2">
                    <v-select class="w-full" placeholder="Teacher"></v-select>
                </div>
                <div style="min-width: 200px;" class="p-2">
                    <div class="flatpickr_with_icon">
                        <flat-pickr
                            class="w-full"
                            placeholder="Start Time"
                        />
                        <vs-icon icon-pack="feather" icon="icon-clock" />
                    </div>
                </div>
                <div style="min-width: 200px;" class="p-2">
                    <div class="flatpickr_with_icon">
                        <flat-pickr
                            class="w-full"
                            placeholder="End Time"
                        />
                        <vs-icon icon-pack="feather" icon="icon-clock" />
                    </div>
                </div>
                <div class="weekday_holder">
                    <ul class="inline-flex">
                        <li class="active">M</li>
                        <li class="active">T</li>
                        <li>W</li>
                        <li>Th</li>
                        <li>F</li>
                        <li>Sa</li>
                        <li>Su</li>
                    </ul>
                </div>
                <div class="px-4">
                    <span style="color: red; cursor: pointer;" class="material-icons-outlined">delete</span>
                </div>
            </div>
        </div>
        <div class="mt-4">
            <a style="cursor: pointer;" class="inline-flex items-center pr-4">
                <span style="font-size: 16px;" class="material-icons-outlined">add_circle_outline</span>
                <span class="pl-1">Add Period</span>
            </a>
            <a style="cursor: pointer;" class="inline-flex items-center pl-4">
                <span style="font-size: 16px;" class="material-icons-outlined">add_circle_outline</span>
                <span class="pl-1">Add Break</span>
            </a>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

export default {
  components: {
    vSelect,
    flatPickr
  }
}
</script>